
import React from 'react'
import img000 from '../components/images/sample.png'
import img2046 from '../components/images/adamazon.png'
import img2046a from '../components/images/adamazon1.png'
import img2046b from '../components/images/adamazon2.png'
import img2046c from '../components/images/adamazon3.png'
import img2046d from '../components/images/adamazon4.webp'
import img2046e from '../components/images/adamazon5.webp'
import img2046f from '../components/images/adamazon6.webp'
import img2046g from '../components/images/adamazon7.webp'
import img2046h from '../components/images/adamazon8.webp'
import img2046i from '../components/images/adamazon9.webp'
import img2046j from '../components/images/adamazon10.webp'

const events = () => {
    return (

        <>
            <div className='container'>
                <div className="row  m-2">
                    <img src={img2046} alt='amazon' />
                </div>
                <div className='container text-center'>
                    <h2>Introduction To Amazon Ads</h2>
                    <p>
                        Drive sales and visibility with targeted advertising on the world’s largest online marketplace, reaching millions of potential customers. Leverage advanced targeting options to precisely reach your ideal audience, optimize campaigns for maximum ROI, and increase brand awareness. With Amazon Ads, tap into powerful analytics to refine your strategies and stay ahead in the competitive e-commerce landscape.
                    </p>
                </div>

                <div className='row'>
                    <h2 className='text-center' >Sponsored Product Ads</h2>
                    <div className='col'>
                        <ol>
                            <li><b>1.	Manual Ads</b> <br />Keyword Targeting <br />
                                Product Targeting
                            </li>
                            <li><b>2.	Automatic Ads</b></li>
                        </ol>
                    </div>
                    <div className='col'>
                        <img src={img2046a} alt='Queryimg' />
                    </div>
                </div >

                <div className='row'>
                    <h2 className='text-center' >Sponsored Brand Ads</h2>
                    <div className='col'>
                        <ol>
                            <li><b>1.	Store Spotlight</b> </li>
                            <li><b>2.	Product Collection</b></li>
                            <li><b>3.	Sponsored Video Ads</b></li>
                        </ol>
                    </div>
                    <div className='col'>
                        <img src={img2046b} alt='Queryimg' />
                    </div>
                </div >
                <div className='row'>
                    <h2 className='text-center' >Sponsored Display Ads</h2>
                    <div className='col'>

                        <ol>
                            <li><b>1.	Product Targeting</b> </li>
                            <li><b>2. Audience Targeting</b></li>
                            <li><b>3. Category Targeting</b></li>
                            <li><b>4.	Video Targeting</b></li>
                        </ol>
                    </div>
                    <div className='col'>
                        <img src={img2046c} alt='Queryimg' />
                    </div>
                </div >
                <div className='row'>
                    <h2 className='text-center' >Optimize Your Keyword & Product Targeting</h2>
                    <p className='text-center'>Enhancing your targeting strategy during live campaigns can greatly improve performance. This involves refining targeting based on campaign insights. By following these steps, you can:</p>
                    <div className='col'>

                        <ol>
                            <li>1.	Assess and choose the best targeting strategies for your specific campaign.</li>
                            <li>2.	Adjust targeting methods to align more closely with your campaign objectives.</li>
                            <li>3.	Implement effective techniques to optimize targeting strategies across different campaigns.</li>
                        </ol>
                    </div>
                    <div className='col'>
                        <img src={img2046d} alt='Queryimg' />
                    </div>
                </div >
                <div className='row'>
                    <h2 className='text-center' >Optimize Your Bids & Budgets</h2>
                    <p className='text-center'>Throughout your campaign, adjusting your bidding and budgeting strategies can enhance overall performance. This guide focuses on optimizing these aspects based on campaign insights. By completing this guide, you will:</p>
                    <div className='col'>

                        <ol>
                            <li>1.	Monitor campaign performance against budgetary targets.</li>
                            <li>2.	Refine your sponsored ads strategies to improve bidding and budgeting.</li>
                            <li>3.	Identify critical campaign metrics to guide bidding optimizations.</li>
                        </ol>
                    </div>
                    <div className='col'>
                        <img src={img2046e} alt='Queryimg' />
                    </div>
                </div >
                <div className='row'>
                    <h2 className='text-center' >Optimize Your Campaigns & Creatives</h2>
                    <p className='text-center'>Refining your campaigns and creative elements based on insights can significantly enhance their effectiveness. This guide covers efficient campaign creation through bulk operations, testing creative variations, and leveraging insights for optimal campaign performance. By mastering these techniques, you will:</p>
                    <div className='col'>

                        <ol>
                            <li>1.	Conduct systematic tests on ad creatives to analyze performance and guide strategic decisions.</li>
                            <li>2.	Implement data-driven improvements to enhance overall campaign effectiveness.</li>
                            <li>3.	Streamline campaign creation and management using bulk operations to drive efficiency.</li>
                        </ol>
                    </div>
                    <div className='col'>
                        <img src={img2046f} alt='Queryimg' />
                    </div>
                </div >
                <div className='row'>
                    <h2 className='text-center' >Optimize Your Sponsored Ads Campaigns</h2>
                    <p className='text-center'>Using campaign insights for sponsored ads, you’ll analyze performance, identify opportunities, and make strategic adjustments to achieve your business goals effectively. Prior familiarity with Amazon Ads console, targeting, bids, budgets, promoted product performance, and campaign creative is assumed. Throughout this guide, you’ll deepen your understanding of these areas and integrate best practices for timing, landing pages, and creatives to expand your reach across every stage of the shopping journey.</p>
                    <div className='col'>

                        <ol>
                            <li>1.	Evaluating and refining keyword, contextual targeting, and audience strategies aligned with your business objectives.</li>
                            <li>2.	Fine-tuning bids and budgets to optimize campaign performance and achieve your goals</li>
                        </ol>
                    </div>
                    <div className='col'>
                        <img src={img2046g} alt='Queryimg' />
                    </div>
                </div >
                <div className='row'>
                    <h2 className='text-center' >Use Sponsored Ads To Help Grow Your Brand</h2>
                    <p className='text-center'>In this guide, you’ll explore the customer journey on Amazon and discover effective strategies using both free and paid advertising solutions. These include Sponsored Ads, Stores, Brand Follow, and Posts, which collectively contribute to expanding your brand’s presence and growth on Amazon.</p>
                    <div className='col'>

                        <ol>
                            <li>•	Understand the strategic value of growth marketing for your brand.</li>
                            <li>•	Identify and leverage various advertising options available on Amazon.</li>
                            <li>•	Align your products and metrics with specific growth marketing objectives to drive success.</li>
                        </ol>
                    </div>
                    <div className='col'>
                        <img src={img2046h} alt='Queryimg' />
                    </div>
                </div >
                <div className='row'>
                    <h2 className='text-center' >Drive discoverability with Sponsored Brands</h2>
                    <p className='text-center'>Explore the advantages of Sponsored Brands, integrating them into your campaigns, evaluating performance, and making strategic enhancements. By completing this, you’ll be equipped to:</p>
                    <div className='col'>

                        <ol>
                            <li>•	Launch your own Sponsored Brands campaigns</li>
                            <li>•	Engage audiences effectively with Sponsored Brands videos</li>
                            <li>•	Refine your Sponsored Brands strategy using critical metrics and business goals</li>
                            <li>•	Understand and apply design and content guidelines, along with best practices, for Sponsored Brands video creatives</li>
                        </ol>
                    </div>
                    <div className='col'>
                        <img src={img2046i} alt='Queryimg' />
                    </div>
                </div >
                <div className='row'>
                    <h2 className='text-center' >Reach shoppers with Sponsored Display Ads</h2>
                    <p className='text-center'>Explore Sponsored Display, Amazon’s self-service display advertising solution, and its strategic benefits for advertising. Learn best practices for setting up campaigns and utilize available metrics for effective optimization. Understand:</p>
                    <div className='col'>

                        <ol>
                            <li>•	Implementing Sponsored Display to boost brand visibility and product promotion</li>
                            <li>•	Optimizing campaign setup for maximum advertising impact</li>
                            <li>•	Analyzing metrics to refine and enhance advertising performance</li>
                        </ol>
                    </div>
                    <div className='col'>
                        <img src={img2046j} alt='Queryimg' />
                    </div>
                </div >
            </div>
        </>
    )
}

export default events